import SlotSheetOverLay from "../calendar/common/slot-sheet-overlay";
import Main from "../calendar/slot-visit/main";
import { type Slot } from "../calendar/slot-visit/types";

interface VisitSchedulingOverlayProps {
	isOpen: boolean;
	onClose: () => void;
	unitId?: string;
	projectId?: string;
	userId?: string;
	buyerId?: string;
	propertyName?: string;
	onScheduleComplete?: (slots: { start: string; end: string }[]) => void;
}

export function VisitSchedulingOverlay({
	isOpen,
	onClose,
	unitId,
	projectId,
	userId,
	buyerId,
	// propertyName,
	onScheduleComplete,
}: VisitSchedulingOverlayProps) {
	const handleScheduleVisit = (slots: Slot[]) => {
		const formattedSlots = slots.map(({ start, end }) => ({
			start: typeof start === "string" ? start : start.toISOString(),
			end: typeof end === "string" ? end : end.toISOString(),
		}));
		onScheduleComplete?.(formattedSlots);
		onClose();
	};

	if (!isOpen) return null;
	return (
		<SlotSheetOverLay header="Schedule Visit" isOpen={isOpen} onClose={onClose}>
			<div className="flex-1 h-[80dvh] overflow-y-auto pt-4 pl-4 pr-4 pb-0">
				<p className="text-sm text-gray-600 mt-1">Please select at least 4 slots</p>
				<Main
					onChange={handleScheduleVisit}
					setLoading={() => {}}
					unitId={unitId}
					userId={userId || ""}
					projectId={projectId}
					buyerId={buyerId || ""}
					minSlots={4}
					className="h-auto! flex-1 "
					onClick={onClose}
				/>
			</div>
		</SlotSheetOverLay>
	);
}
